/*
  COTANTIN — 定期便「お届け方法」（VID 適用 実装指示書 v1.16 §3.8.2）
  snippets/cotantin-sub-purchase.liquid が出す <cotantin-sub> を動かす。

  - 「今回のみ」／「定期便」の切り替え、周期のピル、数量ステッパー（定期便は最大 data-max）
  - 購入フォームの selling_plan と quantity に値を入れる（「今回のみ」のときは selling_plan を無効にして送らない）
  - サイズを切り替えると Prestige が liquid ブロックを描き直すので、選択状態は商品ごとに window に覚えておき、
    描き直されて connectedCallback が走るたびに戻す
  - 連動して書き換えるもの：先頭の価格（.ct-pdp-price）、周期に追従する注記（<cotantin-sub-note>）、
    スマホの追従バー（.ct-sticky-sp）、サイズのピルの表記（「10mm」＋小さく「4ピース」）
  - 計測：お客さまが選び直したときに sub_select（mode・plan・qty）を Shopify のカスタマーイベントに流す
  - layout="toggle"（2026-10-31 代表決定の下絵「底鋲カバー」）：1行の切り替え（今回のみ ◯ 定期便）。
    「今回のみ」の数量は価格とボタンのあいだの <cotantin-sub-qty>（別の liquid ブロック）。
    「?」で「お届け方法について」（assets/cotantin-ship.js の説明・key "sub"）。中の周期は選んでいる周期に合わせる
*/
(function () {
  if (!window.customElements || customElements.get('cotantin-sub')) return;

  var store = window.__ctSubState || (window.__ctSubState = {});

  function yen(cents) {
    return Math.round(Number(cents) / 100).toLocaleString('ja-JP');
  }

  function track(name, params) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, params);
      }
    } catch (e) { /* 計測の失敗で操作を止めない */ }
  }

  class CotantinSub extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var json = this.querySelector('[data-sub-json]');
      try { this.data = JSON.parse(json ? json.textContent : '{}'); } catch (e) { this.data = { variants: {} }; }

      this.pid = this.getAttribute('data-product-id');
      this.formId = this.getAttribute('data-form-id');
      this.max = parseInt(this.getAttribute('data-max'), 10) || 3;
      this.pills = Array.prototype.slice.call(this.querySelectorAll('[data-plan]'));

      var st = store[this.pid];
      if (!st) {
        // ?selling_plan=… で来たとき（例：底鋲カバーのご案内ページの「定期便で受け取る」）は、その周期を初期選択にする
        var selected = this.getAttribute('data-selected-plan') || '';
        var hasSelected = selected && this.pills.some(function (p) { return p.getAttribute('data-plan') === selected; });
        st = store[this.pid] = {
          mode: hasSelected ? 'subscription' : (this.getAttribute('data-default-mode') === 'once' ? 'once' : 'subscription'),
          plan: hasSelected ? selected : (this.pills[0] ? this.pills[0].getAttribute('data-plan') : ''),
          qty: 1
        };
      }
      this.st = st;

      var self = this;
      this.querySelectorAll('.ct-sub__radio').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          st.mode = radio.value;
          if (st.mode === 'subscription') st.qty = Math.min(st.qty, self.max);
          self.apply();
          self.report();
        });
      });

      this.pills.forEach(function (pill) {
        pill.addEventListener('click', function (e) {
          e.preventDefault();
          st.mode = 'subscription';
          st.plan = pill.getAttribute('data-plan');
          self.apply();
          self.report();
        });
      });

      this.querySelectorAll('[data-step]').forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();
          var box = button.closest('[data-mode]');
          if (box) st.mode = box.getAttribute('data-mode');
          var limit = st.mode === 'subscription' ? self.max : 99;
          st.qty = Math.max(1, Math.min(limit, st.qty + parseInt(button.getAttribute('data-step'), 10)));
          self.apply();
          self.report();
        });
      });

      // 切り替え（layout="toggle"）
      var sw = this.querySelector('[data-sub-switch]');
      if (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          st.mode = st.mode === 'subscription' ? 'once' : 'subscription';
          if (st.mode === 'subscription') st.qty = Math.min(st.qty, self.max);
          self.apply();
          self.report();
        });
      }
      var help = this.querySelector('[data-sub-help]');
      if (help) {
        help.addEventListener('click', function (e) {
          e.preventDefault();
          if (window.ctOpenShipSheet) window.ctOpenShipSheet(help, null, 'sub');
        });
      }

      if (!window.__ctSubVariantListener) {
        window.__ctSubVariantListener = true;
        document.addEventListener('variant:change', function () {
          setTimeout(function () {
            document.querySelectorAll('cotantin-sub').forEach(function (el) { if (el.apply) el.apply(); });
          }, 0);
        });
      }

      this.apply();
    }

    variant() {
      var form = document.getElementById(this.formId);
      var input = form && form.querySelector('[name="id"]');
      var id = input ? input.value : Object.keys(this.data.variants || {})[0];
      return { id: id, info: (this.data.variants || {})[id] || null };
    }

    planLabel() {
      var pill = this.pills.find ? this.pills.find(function (p) { return p.getAttribute('data-plan') === this.st.plan; }, this) : null;
      return pill ? pill.getAttribute('data-label') : '';
    }

    report() {
      track('sub_select', { mode: this.st.mode, plan: this.st.mode === 'subscription' ? this.planLabel() : '', qty: this.st.qty });
    }

    apply() {
      var st = this.st;
      var sub = st.mode === 'subscription';
      var v = this.variant();
      var once = v.info ? v.info.price : null;
      var subPrice = v.info && v.info.plans && v.info.plans[st.plan] != null ? v.info.plans[st.plan] : once;

      // 選択の見た目
      this.querySelectorAll('.ct-sub__radio').forEach(function (r) { r.checked = r.value === st.mode; });
      this.querySelectorAll('.ct-sub__box').forEach(function (box) {
        box.classList.toggle('is-selected', box.getAttribute('data-mode') === st.mode);
      });
      this.querySelectorAll('[data-body]').forEach(function (body) {
        body.hidden = body.getAttribute('data-body') !== st.mode;
      });
      this.pills.forEach(function (p) {
        var on = p.getAttribute('data-plan') === st.plan;
        p.classList.toggle('is-selected', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var limit = sub ? this.max : 99;
      this.querySelectorAll('[data-stepper]').forEach(function (s) {
        s.querySelector('[data-count]').textContent = st.qty;
        s.querySelector('[data-step="-1"]').disabled = st.qty <= 1;
        s.querySelector('[data-step="1"]').disabled = st.qty >= limit;
      });

      // フォームへ
      var planInput = this.querySelector('[data-input-plan]');
      planInput.value = sub ? st.plan : '';
      planInput.disabled = !sub;
      this.querySelector('[data-input-qty]').value = st.qty;

      // 箱の中の価格（サイズ・周期で変わる。割引率は周期ごとに違うことがある）
      var percent = once ? Math.round((1 - subPrice / once) * 100) : 0;
      if (once != null) {
        var priceOnce = this.querySelector('[data-price-once]');
        var priceSub = this.querySelector('[data-price-sub]');
        if (priceOnce) priceOnce.textContent = yen(once);
        if (priceSub) priceSub.textContent = yen(subPrice);
        var subNote = this.querySelector('[data-sub-note]');
        if (subNote) subNote.textContent = subNote.getAttribute('data-sub-note').replace('{percent}', percent);
      }

      // 切り替え（layout="toggle"）と、価格とボタンのあいだの数量（今回のみ）
      var sw = this.querySelector('[data-sub-switch]');
      if (sw) sw.setAttribute('aria-checked', sub ? 'true' : 'false');
      this.querySelectorAll('[data-sub-opt]').forEach(function (o) {
        o.classList.toggle('is-on', o.getAttribute('data-sub-opt') === st.mode);
      });
      document.querySelectorAll('cotantin-sub-qty[data-product-id="' + this.pid + '"]').forEach(function (q) {
        q.hidden = sub;
        var count = q.querySelector('[data-count]');
        if (count && count.textContent !== String(st.qty)) count.textContent = st.qty;
        var minus = q.querySelector('[data-step="-1"]');
        var plus = q.querySelector('[data-step="1"]');
        if (minus) minus.disabled = st.qty <= 1;
        if (plus) plus.disabled = st.qty >= 99;
      });

      // 先頭の価格
      var headSub = this.getAttribute('data-head-sub') || '';
      var headSubSp = this.getAttribute('data-head-sub-sp') || headSub;
      var headOnce = this.getAttribute('data-head-once') || '';
      document.querySelectorAll('.ct-pdp-price').forEach(function (price) {
        var num = price.querySelector('.ct-pdp-price__num');
        var note = price.querySelector('.ct-pdp-price__note');
        if (num && once != null) num.textContent = yen(sub ? subPrice : once);
        // ボタンの左の価格（.ct-pdp-price--cta）は短いほう（例「定期便・税・送料込」）
        var tpl = (price.closest('.ct-pdp-head__price--sp') || price.classList.contains('ct-pdp-price--cta')) ? headSubSp : headSub;
        if (note) note.textContent = sub
          ? tpl.replace('{percent}', percent).replace('{once}', yen(once))
          : headOnce;
      });

      // 周期に追従する注記（と、「お届け方法について」の中の周期）
      var label = this.planLabel();
      document.querySelectorAll('[data-sub-plan-label]').forEach(function (s) {
        if (label && s.textContent !== label) s.textContent = label;
      });
      document.querySelectorAll('cotantin-sub-note[data-product-id="' + this.pid + '"]').forEach(function (n) {
        n.hidden = !sub;
        n.textContent = (n.getAttribute('data-template') || '').replace('{plan}', label);
      });

      // スマホの追従バー「10mm・定期便 3か月ごと×1」
      var size = v.info ? String(v.info.title).split(' ')[0] : '';
      var subWord = this.getAttribute('data-sticky-sub') || '';
      document.querySelectorAll('.ct-sticky-sp').forEach(function (bar) {
        var t = bar.querySelector('.ct-sticky-sp__variant');
        var n = bar.querySelector('.ct-sticky-sp__num');
        if (t) t.textContent = sub ? size + '・' + subWord + ' ' + label + '×' + st.qty : size;
        if (n && once != null) n.textContent = yen(sub ? subPrice : once);
      });

      // サイズのピル：「10mm 4ピース」→「10mm」＋小さく「4ピース」
      var picker = document.querySelector('variant-picker[form-id="' + this.formId + '"]') || document;
      picker.querySelectorAll('.block-swatch > span:only-child').forEach(function (span) {
        var text = span.textContent.trim();
        var cut = text.indexOf(' ');
        if (cut < 1 || span.getAttribute('data-ct-split')) return;
        span.setAttribute('data-ct-split', '1');
        span.textContent = text.slice(0, cut);
        var small = document.createElement('small');
        small.className = 'ct-sub-swatch-sub';
        small.textContent = text.slice(cut + 1);
        span.parentNode.appendChild(small);
      });
    }
  }

  class CotantinSubNote extends HTMLElement {
    connectedCallback() {
      var pid = this.getAttribute('data-product-id');
      var owner = document.querySelector('cotantin-sub[data-product-id="' + pid + '"]');
      if (owner && owner.apply) owner.apply();
    }
  }

  // 価格とボタンのあいだの数量（今回のみ）。描き直されて差し込まれたら、持ち主の状態で描き直す
  class CotantinSubQty extends HTMLElement {
    connectedCallback() {
      var owner = document.querySelector('cotantin-sub[data-product-id="' + this.getAttribute('data-product-id') + '"]');
      if (owner && owner.apply) owner.apply();
    }
  }

  // 数量の「−／＋」（<cotantin-sub-qty> は描き直しで差し替わるので、document で受ける）
  document.addEventListener('click', function (e) {
    var button = e.target.closest('cotantin-sub-qty [data-step]');
    if (!button) return;
    e.preventDefault();
    var pid = button.closest('cotantin-sub-qty').getAttribute('data-product-id');
    var owner = document.querySelector('cotantin-sub[data-product-id="' + pid + '"]');
    if (!owner || !owner.st) return;
    owner.st.mode = 'once';
    owner.st.qty = Math.max(1, Math.min(99, owner.st.qty + parseInt(button.getAttribute('data-step'), 10)));
    owner.apply();
    owner.report();
  });

  // 「お届け方法について」を開いたら、中の周期を選んでいる周期に合わせる（開くたびに写し直されるため）
  document.addEventListener('ct:sheet-open', function () {
    document.querySelectorAll('cotantin-sub').forEach(function (el) { if (el.apply) el.apply(); });
  });

  customElements.define('cotantin-sub', CotantinSub);
  if (!customElements.get('cotantin-sub-qty')) customElements.define('cotantin-sub-qty', CotantinSubQty);
  if (!customElements.get('cotantin-sub-note')) customElements.define('cotantin-sub-note', CotantinSubNote);
})();
